import { render } from "./logOut.vue?vue&type=template&id=5b0422b0&scoped=true"
import script from "./logOut.vue?vue&type=script&lang=js"
export * from "./logOut.vue?vue&type=script&lang=js"

import "./logOut.vue?vue&type=style&index=0&id=5b0422b0&scoped=true&lang=css"

import exportComponent from "F:\\N\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0422b0"]])

export default __exports__